import { Message } from 'element-ui';

const DEFAULT_ERROR_MESSAGE = '操作失败，请稍后重试';

/**
 * 将请求层、Axios 和原生 Error 统一转换为可展示的文本。
 */
export function getErrorMessage(error, fallback = DEFAULT_ERROR_MESSAGE) {
	if (typeof error === 'string' && error.trim()) return error;
	if (error && typeof error.msg === 'string' && error.msg.trim()) return error.msg;
	if (error && typeof error.message === 'string' && error.message.trim()) return error.message;
	return fallback;
}

/**
 * 展示尚未由请求层提示过的错误，避免重复提示和空白 Message。
 */
export function showError(error, fallback = DEFAULT_ERROR_MESSAGE) {
	if (error && error.notified) return false;
	Message.error(getErrorMessage(error, fallback));
	return true;
}

export { DEFAULT_ERROR_MESSAGE };



// WEBPACK FOOTER //
// ./src/utils/error-message.js